import FormControl from '@zenbusiness/zui/FormControl';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import RadioGroup from '@zenbusiness/zui/RadioGroup';
import { superstyled } from '@zenbusiness/zui/styles';

export const StyledFormControl = superstyled({
  name: 'OptionGroup',
  slot: 'Root',
  tag: FormControl,
  propsAdded: {
    fullWidth: true
  },
  styles: () => ({
    width: '100%',
    display: 'block',
    marginBottom: 0
  })
});

export const StyledRadioGroup = superstyled({
  name: 'OptionGroup',
  slot: 'RadioGroup',
  tag: RadioGroup,
  styles: () => ({
    width: '100%'
  })
});

export const StyledOption = superstyled({
  name: 'OptionGroup',
  slot: 'Option',
  tag: FormControlLabel,
  styles: ({ theme }) => ({
    margin: 0,
    padding: '1.375rem 1.25rem',
    width: '100%',
    outline: `solid 1px ${theme.palette.border.dark}`,
    marginBottom: theme.spacing(1),
    borderRadius: theme.shape.rounded.lg,
    color: theme.palette.warning.contrastText,
    '&:last-child': {
      marginBottom: 0
    },

    // Selected state
    '&:has(input:checked), &:focus:not(:focus-visible)': {
      backgroundColor: 'transparent',
      outline: `solid 2px ${theme.palette.info.main}`
    },

    // Hide the radio input
    '& .MuiButtonBase-root.MuiRadio-root': {
      display: 'none'
    }
  })
});
